"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAllChildrenProps = fetchAllChildrenProps;
exports.getAllChildrenProps = getAllChildrenProps;
exports.fetchChildrenProps = fetchChildrenProps;
exports.getChildrenProps = getChildrenProps;
exports.fetchChildren = fetchChildren;
exports.getChildren = getChildren;
exports.fetchElements = fetchElements;
exports.getElements = getElements;
exports.getAllElements = getAllElements;
exports.omitAllElements = omitAllElements;
const react_1 = __importDefault(require("react"));
// all
function fetchAllChildrenProps(children, mapping) {
    const normal = Array.isArray(children) ? children : [children];
    const mapped = getAllChildrenProps(normal, mapping);
    for (const [key, klass] of Object.entries(mapping)) {
        if (!mapped[key]) {
            throw new Error(`required child of type '${klass.name}' not found`);
        }
    }
    return mapped;
}
function getAllChildrenProps(children, mapping) {
    const childrenArray = react_1.default.Children.toArray(children);
    const mapped = Object.entries(mapping).reduce((acc, [key, klass]) => {
        const children = childrenArray
            .filter((candidate) => candidate.type === klass)
            .map((candidate) => candidate.props);
        return {
            ...acc,
            [key]: children,
        };
    }, {});
    return mapped;
}
// props
function fetchChildrenProps(children, mapping) {
    const normal = Array.isArray(children) ? children : [children];
    const mapped = getChildrenProps(normal, mapping);
    for (const [key, klass] of Object.entries(mapping)) {
        if (!mapped[key]) {
            throw new Error(`required child of type '${klass.name}' not found`);
        }
    }
    return mapped;
}
function getChildrenProps(children, mapping) {
    const childrenArray = react_1.default.Children.toArray(children).filter(Boolean);
    const mapped = Object.entries(mapping).reduce((acc, [key, klass]) => {
        const child = childrenArray.find((candidate) => candidate.type === klass);
        if (!child) {
            return acc;
        }
        return {
            ...acc,
            [key]: child.props,
        };
    }, {});
    return mapped;
}
// components
function fetchChildren(children, mapping) {
    const normal = Array.isArray(children) ? children : [children];
    const mapped = getChildren(normal, mapping);
    for (const [key, klass] of Object.entries(mapping)) {
        if (!mapped[key]) {
            throw new Error(`required child of type '${klass.name}' not found`);
        }
    }
    return mapped;
}
function getChildren(children, mapping) {
    const childrenArray = react_1.default.Children.toArray(children);
    const mapped = Object.entries(mapping).reduce((acc, [key, klass]) => {
        const child = childrenArray.find((candidate) => candidate.type === klass);
        if (!child) {
            return acc;
        }
        const Comp = (props) => react_1.default.cloneElement(child, { ...child?.props, ...props });
        return {
            ...acc,
            [key]: Comp,
        };
    }, {});
    return mapped;
}
function fetchElements(children, mapping) {
    const normal = Array.isArray(children) ? children : [children];
    const mapped = getElements(normal, mapping);
    for (const [key, klass] of Object.entries(mapping)) {
        if (!mapped[key]) {
            throw new Error(`required child of type '${klass.name}' not found`);
        }
    }
    return mapped;
}
function getElements(children, mapping) {
    const childrenArray = react_1.default.Children.toArray(children);
    const mapped = Object.entries(mapping).reduce((acc, [key, klass]) => {
        const child = childrenArray.find((candidate) => candidate.type === klass);
        if (!child) {
            return acc;
        }
        return {
            ...acc,
            [key]: child,
        };
    }, {});
    return mapped;
}
function getAllElements(children, mapping) {
    const childrenArray = react_1.default.Children.toArray(children);
    const mapped = Object.entries(mapping).reduce((acc, [key, klass]) => {
        const children = childrenArray
            .filter((candidate) => candidate.type === klass)
            .map((candidate) => candidate.props);
        return {
            ...acc,
            [key]: children,
        };
    }, {});
    return mapped;
}
function omitAllElements(children, omitted) {
    const childrenArray = react_1.default.Children.toArray(children);
    const mapped = childrenArray
        .filter((candidate) => !omitted.some((Component) => Component === candidate.type))
        .map((candidate) => candidate);
    return mapped;
}
//# sourceMappingURL=childrenHelper.js.map